import React from 'react';
import { CreditasAnalysisResponsible } from '../../../components/CreditasAnalysisResponsible';
import { PersonTypesEnum } from '../../../enums/person-types.enum';
import { PurposesEnum } from '../../../enums/purposes.enum';
import { Grid } from 'semantic-ui-react';
import { Info } from '../../../components/Info';
import { DateToStringDate } from '../../../services/date';
import { AnalysisAssuranceEnum } from '../../../enums/analysis-assurance.enum';
import { BondInsuranceForGetBondInsurancesResponseDTO } from "../../../dtos/bond-insurance-list/get-bond-insurances-response.dto";
import { BondInsuranceAnalysis } from '../../../types/BondInsuranceAnalysis';
import { EstateInsurerDataForGetEstatesResponseDTO, InsurerForGetEstateResponseDTO } from '../../../dtos/estate/estate-for-get-estates-response.dto';
import { InsurersCodeEnum } from '../../../enums/insurers-code.enum';
import { FieldLabel } from '../../../styles';
import { formatAmount } from '../../../services/masks';
import moment from 'moment-timezone';

export type Props = {
  bondInsurance: BondInsuranceForGetBondInsurancesResponseDTO;
  insurersData: EstateInsurerDataForGetEstatesResponseDTO[];
  insurers: InsurerForGetEstateResponseDTO[];
};

export const BondInsuranceMainInfoDetails = (props: Props) => {

  const { bondInsurance, insurersData, insurers } = props;
  const { property } = bondInsurance;

  return (
    <>
      <Grid.Row>
        <Info name={'ID'} value={bondInsurance.id} width={8} />
      </Grid.Row>
      <Grid.Row>
        <Info name={'DATA DE EMISSÃO '} value={DateToStringDate(bondInsurance.created_at)} width={8} />
        <Info name={'CRIADA POR'} value={bondInsurance.user?.name} width={8} />
      </Grid.Row>
      <Grid.Row>
        <Info name={'IMOBILIÁRIA'} value={bondInsurance.estate?.name} width={8} />
      </Grid.Row>
      <Grid.Row>
        <Info name={'FINALIDADE'} value={bondInsurance.purpose === PurposesEnum.commercial ? 'Comercial' : 'Residencial'} width={8} />
        <Info name={'TIPO DE LOCATÁRIO'} value={bondInsurance.tenant_type === PersonTypesEnum.legal ? 'Pessoa Jurídica' : 'Pessoa Física'} width={8} />
      </Grid.Row>
      <Grid.Row>
        <Info name={'MOTIVO DA LOCAÇÃO'} value={property.reason} width={8} />
        <Info name={'GESTOR DE CONTAS'} value={bondInsurance.estate?.user.name} width={8} />
      </Grid.Row>
      <Grid.Row>
        <Info name={'VIGÊNCIA DO CONTRATO'} value={`${property.validity} MESES`} width={8} />
        <Info name={'DIA DE VENCIMENTO DO ALUGUEL'} value={`${property.rent_due_date ||  'Indisponível'}`} width={8} />
      </Grid.Row>
      {property.location_in_progress &&
        <Grid.Row>
          <Info name={'CONTRATO DE LOCAÇÃO VIGENTE'} value={`${property.location_in_progress ? 'SIM' : 'NÃO'}`} width={6} />
          <Info name={'Início da Locação'} value={moment(property.rent_insurance_contract_start_date).format('DD/MM/YYYY')} width={5} />
          <Info name={'Fim da Locação'} value={moment(property.rent_insurance_contract_end_date).format('DD/MM/YYYY')} width={5} />
        </Grid.Row>
      }
      <CreditasAnalysisResponsible
        estateId={bondInsurance.estate?.id}
        visible={bondInsurance.bond_insurance_analysis?.some(
          analysis => analysis.insurer?.code === InsurersCodeEnum.Creditas
        ) || false}
      />
      <FieldLabel paddingTop={true}>SEGURADORAS / GARANTIDORAS ATIVAS </FieldLabel>
      <Grid.Row>
        <div style={{overflow: 'auto', display: 'flex', flexDirection: 'row', gap: '1rem', width: '80vw', whiteSpace: 'nowrap', marginLeft: '1rem'}}>
       {
        insurers?.map((insurer, index) =>
         {
          const insurerData = insurersData?.find(c => c.insurer.id === insurer.id)
          const insurerCode = insurerData?.insurer?.code || insurer.code
          const insurerName = insurerData?.insurer?.name || insurer.name || insurerCode
          return (
          <div key={insurer.id || index} style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'left',
            alignItems: 'left',
            width: '240px',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            marginBottom: '10px',
          }}>
            <h3 style={{fontSize: '14px', fontWeight: "bold", marginBottom: '4px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{insurerName}</h3>
            {
              insurerCode === InsurersCodeEnum.Creditas ?
                <p style={{fontSize: '14px'}}>Análise manual via HubA</p>
              :
              insurerCode === InsurersCodeEnum.Porto ||  insurerCode === InsurersCodeEnum.Too ?
                <p style={{fontSize: '14px'}}>Taxa, cobertura e LMI: <br/>  &nbsp; &nbsp; Por Oferta Aprovada </p>
              :

              insurerCode === InsurersCodeEnum.PortoEssencial ?
              <p style={{fontSize: '14px', }}>Cobertura: {insurerData?.assurance === AnalysisAssuranceEnum.complete ? 'Completa' : 'Simples'}<br/>
                LMI e Taxas: Por Oferta Aprovada </p>
              :
              insurerData ?
              <p style={{fontSize: '14px', }}>Cobertura: {insurerData.assurance === AnalysisAssuranceEnum.complete ? 'Completa' : 'Simples'}; {insurerCode === InsurersCodeEnum.Pottencial ? <span>Multiplo: {insurerData.multiple}</span>  : (insurerData?.lmi > 0 && <span>LMI: {insurerData.lmi}x</span>)  }<br/>
              {
                parseFloat(insurerData.pf_comercial_tax) > 0 && <span> Taxa Comercial: {formatAmount((parseFloat(insurerData.pf_comercial_tax) * 100).toFixed(2))}% <br/></span>
              }

              {
                parseFloat(insurerData.pf_residential_tax) > 0 && <span> Taxa Residêncial: {formatAmount((parseFloat(insurerData.pf_residential_tax) * 100).toFixed(2))}% <br/></span>
              }
              </p>
              :
              <p style={{fontSize: '14px'}}>Seguradora ativa</p>
            }

          </div>)}
        )
       }
        </div>
      </Grid.Row>
    </>
  )
}
